/*=========================================================================================
  File Name: index.js
  Namespace: instructors
  Description: Vuex Instructor Store
==========================================================================================*/

import {
  listInstructors,
  getInstructor
} from '@/services/instructors.service.js'

const state = {
  instructorList: {},
  count: 0,
  next: null,
  previous: null,
  results: []
}

const getters = {
  getInstructors(state) {
    return Object.entries(state.instructorList).map(([key, value]) => {
      return {
        label: value.name.charAt(0).toUpperCase() + value.name.slice(1),
        value: key
      }
    })
  },
  getInstructorsEntries(state) {
    return state.instructorList
  }
}

const mutations = {
  STORE_INSTRUCTOR_LIST(state, instructors) {
    state.instructorList = {
      ...state.instructorList,
      ...instructors.entries
    }
    state.count = instructors.count
    state.next = instructors.next
    state.previous = instructors.previous
    state.results = [...state.results, ...instructors.results]
  },
  RESET_INSTRUCTORS(state) {
    state.instructorList = {}
  }
}

const actions = {
  async getInstructor({
    commit
  }, instructorId) {
    const response = await getInstructor({
      instructorId: instructorId
    })
    if (response) {
      commit('STORE_INSTRUCTOR_LIST', response)
    }
    return response
  },
  async getAllInstructors({
    commit, rootState
  }, params = {}) {
    params.company = rootState.app.company
    params.page_size = params.page_size ? params.page_size : 256
    const response = await listInstructors(params)
    if (response) {
      commit('STORE_INSTRUCTOR_LIST', response)
    }
    return response
  },
  async searchInstructors(context, params = {}) {
    const response = await listInstructors(params)
    return response
  },
  resetCurrentInstructors({
    commit
  }) {
    commit('RESET_INSTRUCTORS')
  }
}

export default {
    namespaced: true,
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
}